
import Vue from "vue"

import NoticeContent from "./NoticeContent.vue"

const types = ["normal", "info", "success", "warning", "error"]

export default Vue.extend({
  name: "CripNotice",

  components: { NoticeContent },

  props: {
    type: {
      type: String,
      required: true,
      validator: (value: string) => types.indexOf(value) > -1,
    },
    className: { type: String },
    closable: { type: Boolean, required: true },
    description: { type: String },
    duration: { type: Number, required: true },
    icons: { type: Object, required: true },
    name: { type: String, required: true },
    onClose: { type: Function },
    styles: { type: Object, default: () => ({}) },
    title: { type: String, required: true },
  },

  computed: {
    withDesc(): boolean {
      return !!this.description
    },
  },

  data() {
    return {
      closeTimer: 0,
    }
  },

  methods: {
    setCloseTimer() {
      if (this.duration !== 0) {
        this.closeTimer = window.setTimeout(() => {
          this.close()
        }, this.duration * 1000)
      }
    },

    clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = 0
      }
    },

    close() {
      this.onClose()
      this.clearCloseTimer()
      const parent = this.$parent.$parent as any
      parent.remove(this.name)
    },
  },

  mounted() {
    this.clearCloseTimer()
    this.setCloseTimer()
  },

  beforeDestroy() {
    this.clearCloseTimer()
  },
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Notice.vue